<!-- h-dvh (PAS min-h) : le shell est borné à l'écran et les pages défilent EN INTERNE.
     Avec min-h, la page grandissait avec le contenu (listes longues) et tous les h-full en
     dessous devenaient inopérants : le volet détail s'ouvrait hors champ (invisible). -->
<div class="h-dvh md:h-screen flex">
  <div class="h-dvh md:h-screen flex ui-app-shell flex-1 w-full">
    <app-sidenav class="ui-side-divider relative z-50 shrink-0" [home]="home" [links]="links()"> </app-sidenav>

    <!-- overflow-y-auto = soupape : les pages v2 (bornées) ne défilent pas ici,
         mais une page à défilement long reste utilisable. -->
    <main class="flex-1 min-w-0 min-h-0 overflow-y-auto overflow-x-hidden">
      <app-inventory-banner />
      <router-outlet></router-outlet>
    </main>

    <app-toast></app-toast>

    <app-command-palette [links]="links()" />

    <app-modal [(open)]="app.dialogOpen" [closeOnBackdrop]="app.dialogCloseOnBackdrop()">
      @if (app.dialogComponent()) {
      <ng-container *ngComponentOutlet="app.dialogComponent(); inputs: app.dialogInputs()"></ng-container>
      } @else if (app.dialogTemplate()) {
      <ng-container *ngTemplateOutlet="app.dialogTemplate()!; context: app.dialogInputs()"></ng-container>
      }
    </app-modal>
  </div>
</div>
